import React from 'react';
import { View } from 'react-native';
import { Text } from '@shared/components/text';
import { Head } from '@shared/components/head';
import Button from '@shared/components/md-design-system/Button/Button';
import { Icon } from '@ant-design/react-native';
import { colorPalette } from '@shared/config/colorsConfig';
import { dynamicTranslations } from '@shared/utils/dynamicTranslation';
import { IAppointmentReport } from '../../types/Documents';
import { formatDocumentDate } from '../../utils/documentUtils';
import { useAppointmentReportDownload } from '../../hooks/useAppointmentReportDownload';

interface AppointmentReportCardProps {
  report: IAppointmentReport;
}

export const AppointmentReportCard: React.FC<AppointmentReportCardProps> = ({ report }) => {
  const { t } = dynamicTranslations();
  const { downloadAndView, isDownloading } = useAppointmentReportDownload();
  const s = 'history.documents.patientSection';

  return (
    <View className="bg-white rounded-2xl mb-4 border border-gray-200 p-4">
      <View className="flex-row items-start justify-between mb-1">
        <View className="flex-1 mr-3">
          <Head type="h3" className="text-black">
            {t(`${s}.appointmentReport.title`)}
            {'\n'}({report.examName})
          </Head>
        </View>
        {report.createdBy && (
          <View className="flex-row items-center gap-1">
            <Icon name="upload" size={12} color={colorPalette.gray[500]} />
            <Text className="text-xs text-gray-500">
              {t(`${s}.uploadedBy`, { name: report.createdBy })}
            </Text>
          </View>
        )}
      </View>

      <Text className="text-base text-gray-500 mb-2">
        {t(`${s}.uploadedOn`, { date: formatDocumentDate(report.createdAt) })}
      </Text>

      <View className="flex-row gap-3 mt-1">
        <View className="self-start">
          <Button icon="eye" variant="primary" onPress={() => downloadAndView(report.id)} disabled={isDownloading === report.id}>
            {isDownloading === report.id ? t(`${s}.viewing`) : t(`${s}.view`)}
          </Button>
        </View>
      </View>
    </View>
  );
};
